import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card = ({ children, className = "" }: CardProps) => (
  <div className={`bg-white border border-slate-100 rounded-xl p-6 shadow-[0_1px_3px_rgba(0,0,0,0.04)] ${className}`}>
    {children}
  </div>
);

export default Card;